<template>
	<!-- <content-head title="Home" /> -->
	<heading title="Dashboard, Metrics" />
	<content class="">
		<div class="row">
			<div class="card custom-card col-xl-12 rounded-0 border-0 shadow">
				<div class="row card-body">
					<div class="row">
						<div class="col-12 float-sm-left text-start">
							<h4 class="m-0 text-dark" style="font-family: NunitoBlack">
								<i class="nav-icon fas fa-home"></i>
								Custom Dashboards&nbsp;&nbsp;
							</h4>
						</div>
					</div>
				</div>
			</div>
		</div>
	</content>
</template>

<script>
export default {};
</script>



